import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";

export const setSelectedFirmId = (firmId: string): void => {
  try {
    localStorage.setItem("koruFirmId", firmId.trim());
  } catch (error: unknown) {
    appFaultModel.catchAppError("FirmModel.setSelectedFirmId", { firmId }, error);
  }
};
